import React from 'react';
import { Container } from 'reactstrap';
import UiContent from '../../Components/Common/UiContent';
import Calendar from './Calendar';
import BreadCrumb from '../../Components/Common/BreadCrumb';


const MainCalendar = () => {
    const breadcrumbLinks = [
		{ to: '#', label: 'Inicio' },
	];
    return (
        <React.Fragment>
            <UiContent />
            <div className='page-content'>
                <Container fluid>
                    <BreadCrumb title='Calendario' links={breadcrumbLinks} />
                    <Calendar />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default MainCalendar;
